import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../context/app/appContext';
import { Grid, Card, Container, Modal, Button } from 'semantic-ui-react';
import axios from "axios";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

export const SettingsIntegrations = () => {
    const baseURL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_HOST_URL : "http://localhost:8080";
    const iconURL = `https://s3.us-east-2.amazonaws.com/client.staging.perkfix.com/assets/images/integration-logos/`;
    const green = "rgba(0, 200, 136, 1";
    const blue = "#0770CC";
    const grey = "rgba(0, 0, 0, 0.5)";
    const accessToken = localStorage.getItem("accessToken");
    const appContext = useContext(AppContext)
    // const [bgColor, setBgColor] = useState();
    // const [btnText, setBtnText] = useState("Connect");


    const IntegrationsData = [
        {
            title: "Slack",
            imgUrl: "slack.png",
            connected: "false",
            status: "true"
        },
        {

            title: "MS Teams",
            imgUrl: "msteams.png",
            connected: "false",
            status: "true"
        },
        {
            title: "Google Workplace",
            imgUrl: "gsuite.png",
            connected: "true",
            status: "true",
        },
        {
            title: "Rippling",
            imgUrl: "rippling.png",
            connected: "false",
            status: "true"
        }, {

            title: "Facebook Workplace",
            imgUrl: "facebook.png",
            connected: "false",
            status: "false"
        },
        {

            title: "Okta",
            imgUrl: "okta.png",
            connected: "false",
            status: "true"
        }
    ]
    const [integrationsList, setIntegrationsList] = useState(IntegrationsData);
    const [showAuthModal, setShowAuthModal] = useState(false)
    const [showAdminLinkModal, setShowAdminLinkModal] = useState(false)
    const [showCopy, setShowCopy] = useState(false)
    const [integrationAuthType, setIntegrationAuthType] = useState(null)
    const [showInfoModal, setShowInfoModal] = useState(false)
    const [infoModalData, setInfoModalData] = useState(false)

    console.info({ integrationsList })

    const googleSDK = () => {
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
            fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'google-jssdk'));

        window['googleSDKLoaded'] = () => {
            window['gapi'].load('auth2', () => {
                window['gapi'].auth2.init({
                    apiKey: 'AIzaSyBFceVWC7ZJ4Pmo-1gtQETtvmvs_kdf6qc',
                    client_id: '955194124980-95bldgbkns78cqbvb2k45vqjilhogrb6.apps.googleusercontent.com',
                    discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/admin/directory_v1/rest"],
                    scope: 'https://www.googleapis.com/auth/admin.directory.user.readonly',
                    // cookiepolicy: 'single_host_origin',
                //   redirect_uri: 'https://www.google.com'
                }).then((r) => {
                    console.log("Here")
                    console.log(window['gapi'].auth2.getAuthInstance().isSignedIn.get())
                    if(window['gapi'].auth2.getAuthInstance().isSignedIn.get()){
                        console.info({r})
                    }
                    var options = new window['gapi'].auth2.SigninOptionsBuilder();
                    options.setPrompt('select_account');
                    window['gapi'].auth2.getAuthInstance().signIn(options).then(async resp => {
                        const onboardingStatusUpdate = await axios.post(`${baseURL}/onboard-provider/status`, {provider: 'gSuite', status: 'requested', organizationId: appContext.organization._id});
                        console.log("My data", onboardingStatusUpdate)
                        if (onboardingStatusUpdate.status === 200) {
                            const splitEmail = resp.getBasicProfile().getEmail().split('@')
                            const domain = splitEmail[splitEmail.length-1]
                            console.info({domain})
                            const gSuiteOnboardResponse = await axios.post(baseURL + "/gSuite-accessToken", {accessToken: resp.getAuthResponse().access_token, organizationId: appContext.organization._id, domain})
                            // console.info(resp.directory)
                            // console.log(window['gapi'].client)
                            console.info({gSuiteOnboardResponse})
                            if(gSuiteOnboardResponse.status === 200){
                                setInfoModalData(gSuiteOnboardResponse.data.data.result)
                                setShowInfoModal(true)
                            }
                        }
                        // resp.disconnect();
                        window['gapi'].auth2.disconnect();
                    })
                }).catch(error => {
                    console.info({error})
                })
            });
        }
     
        // (function(d, s, id){
        //   var js, fjs = d.getElementsByTagName(s)[0];
        //   if (d.getElementById(id)) {return;}
        //   js = d.createElement(s); js.id = id;
        //   js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
        //   fjs.parentNode.insertBefore(js, fjs);
        // }(document, 'script', 'google-jssdk'));
    }

    const updateConnectionStatus = async (integration) => {
        console.log(integration)

        switch(integration.title) {
            case 'Slack':
                const slackOrg = await axios.get(`${baseURL}/onboard-provider/status`, {provider: 'slack', status: 'requested', organizationId: String(appContext.organization._id)});
                console.log("My data", slackOrg)
                if (slackOrg.status === 200) {
                    console.log("I am inside slack");
                    const slackRequest = window.open("https://slack.com/oauth/v2/authorize?client_id=1035837421200.1392338645296&scope=app_mentions:read,channels:history,channels:read,chat:write,commands,groups:read,incoming-webhook,team:read,users.profile:read,users:read,users:read.email&user_scope=", "_blank")
                }
                break;
            case "Google Workplace":
                setIntegrationAuthType('gSuite')
                setShowAuthModal(true)
                break;
            default:
                break;
        }
    }

    const listOfIntegrations = integrationsList !== undefined && integrationsList.map((integration, index) => <>
        < Grid.Column >
            <div style={{ width: '100%', backgroundColor: 'white', borderWidth: 1, borderStyle: 'solid', borderColor: 'rgba(216, 216, 216, 0.38)' }}>
                <h1 style={{ margin: "5%", height: "24px", width: "90%", fontStyle: 'SFProText-Medium', fontSize: "15px", fontWeight: "500", color: "rgba(0, 0, 0, 1)", textAlign: 'justify' }}>
                    {integration.title}
                </h1>
                <div style={{ textAlign: 'center', height: "60%", width: "90%" }}>
                    <img src={iconURL + integration.imgUrl} alt={integration.title} style={{ width: "100%", margin: "5%", height: "60%" }}></img>

                </div>

                <div>

                    <button onClick={() => updateConnectionStatus(integration)} disabled={integration.status == "false" ? true : false} style={{
                        border: "none", cursor: "pointer", margin: "5%", height: "55px", width: "90%", backgroundColor:
                            integration.status == "false" ? grey : (integration.connected == "true" ? blue : green)
                        , borderRadius: "28px"
                    }}><span style={{ height: "29px", width: "98px", fontStyle: 'SFProText-Bold', fontSize: "24px", fontWeight: "500", color: "rgba(255, 255, 255, 1)" }}>{integration.status == "false" ? "Coming Soon" : (integration.connected === "false" ? "Connect" : "Connected")}</span></button>

                </div>

            </div>

        </Grid.Column >
    </>
    )
    return (
        <Container>
            <Grid columns={3} stretched style={{ width: '100%', marginRight: 0, height: '100%', minHeight: 800, marginTop: "5vh", marginBottom: "0vh", paddingBottom: 0 }}>
                {integrationsList !== undefined && integrationsList.length ? listOfIntegrations : null}
            </Grid>

            <Modal dimmer={'blurring'} open={showAuthModal} size="mini">
                <Modal.Content>
                    <p>Only the {integrationAuthType} Admin is authorized to onboard using integration.</p>
                    <h3><p>Are you the {integrationAuthType} Account Admin?</p></h3>
                </Modal.Content>

                <Modal.Actions className="" style={{flexDirection: 'column', display: 'flex'}}>
                    <button className="ui button" style={{backgroundColor: '#00CF8F'}} onClick={() => { setShowAuthModal(false); setIntegrationAuthType(null); googleSDK() }}>Yes</button>
                    <button className="ui button" style={{marginTop: 10, backgroundColor: '#0770CC'}} onClick={() => { setShowAuthModal(false); setShowAdminLinkModal(true) }}>No, but I know the admin</button>
                    <button className="ui button" style={{marginTop: 10, backgroundColor: '#FCC65C'}} onClick={() => { setShowAuthModal(false); setIntegrationAuthType(null) }}>Cancel</button>
                </Modal.Actions>
            </Modal>

            <Modal dimmer={'blurring'} open={showAdminLinkModal} size="small">
                <Modal.Content>
                    <p>Share Link with {integrationAuthType} Account Admin</p>
                    <CopyToClipboard 
                        onCopy = {() => {setShowAdminLinkModal(false); setIntegrationAuthType(null); toast.success(`Copied to clipboard`, {autoClose: 3000})}}
                        text={`${process.env.NODE_ENV === "production" ? process.env.REACT_APP_HOST : "http://localhost:3000"}/onboarding/admin/${integrationAuthType}/${appContext.organization._id}`}>
                        <button className="ui button"
                            onMouseEnter={() => setShowCopy(true)}
                            onMouseLeave={() => setShowCopy(false)}
                            // onClick={() => {}}
                            style={{height: 40, width: '100%', borderStyle: showCopy ? 'solid' : 'hidden', borderWidth: 1, borderColor: 'black', }}>
                                {showCopy ? 'Copy to Clipboard' : `${process.env.NODE_ENV === "production" ? process.env.REACT_APP_HOST : "http://localhost:3000"}/onboarding/admin/${integrationAuthType}/${appContext.organization._id}`}
                        </button>
                    </CopyToClipboard>
                </Modal.Content>

                <Modal.Actions className="center align">
                    <button className="ui button" onClick={() => { setShowAdminLinkModal(false); setIntegrationAuthType(null); }}>Close</button>
                </Modal.Actions>
            </Modal>

            <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                <Modal.Content><p>Onboarding Complete</p></Modal.Content>
                {infoModalData ? 
                    <Modal.Content>
                        <p><div style={{color: '#00CF8F'}}>Successfully Uploaded ({infoModalData['success'].length}):</div>
                        <div>{infoModalData['success'].map(name => {return <div>{name}</div>})}</div></p>
                        <p><div style={{color: '#FF5A5F'}}>Failed to upload ({infoModalData['fail'].length}):</div>
                        <div>{infoModalData['fail'].map(name => {return <div>{name}</div>})}</div></p>
                    </Modal.Content>
                :null}
                <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
            </Modal>
        </Container>
    )
}

